import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=6d103fda&scoped=true&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyField.vue?vue&type=style&index=0&id=6d103fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d103fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
